import { render, staticRenderFns } from "./RequestCorridor.vue?vue&type=template&id=9cba85a8&"
import script from "./RequestCorridor.vue?vue&type=script&lang=js&"
export * from "./RequestCorridor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports